/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_SuccessInputs */

const es_chat_tool_detail_success = /** @type {(inputs: Chat_Tool_Detail_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado`)
};

const en_chat_tool_detail_success = /** @type {(inputs: Chat_Tool_Detail_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Chat_Tool_Detail_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_success = /** @type {((inputs?: Chat_Tool_Detail_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_success(inputs)
	return en_chat_tool_detail_success(inputs)
});
export { chat_tool_detail_success as "chat.tool_detail.success" }